// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screening-widget {
  padding: 10px;
  perspective: 6000px;
  height: 48vh;
  width: 40%;
}
.utils {
  position: absolute;
  right: 2%;
  top: 0;
  width: 55% !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/widgets/dev-utils-widget/dev-utils-widget.component.less"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;AAFJ;AAKA;EACI,kBAAA;EACA,SAAA;EACA,MAAA;EACA,qBAAA;AAHJ","sourcesContent":["@import (reference) '../widgets.less';\n\n\n.screening-widget {\n    padding: 10px;\n    perspective: 6000px;\n    height: 48vh;\n    width: 40%;\n   \n}\n.utils{\n    position: absolute;\n    right: 2%;\n    top: 0;\n    width: 55% !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
